import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import QuickbooksAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/QuickbooksAppIcon';

const QuickbooksDesktopStrategy = {
  previewInfo: {
    name: 'QuickBooks Desktop',
    iconSvg: <QuickbooksAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'QuickBooks Desktop',
    category: 'Accounting',
    details: (
      <Typography variant="body1" paragraph>
        Sync your Housecall Pro jobs with your QuickBooks Desktop account on job completed, paid, and invoices. Take
        back your time and eliminate data double entry while reducing accounting mistakes all with our QuickBooks
        Desktop integration.
      </Typography>
    ),
    iconSvg: <QuickbooksAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/vhtkt8xezf',
  },
  sellingPoints: {},
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    description: (
      <Grid container spacing={8}>
        <Grid item>
          <Typography align="left" variant="body1">
            <a href="https://quickbooks.intuit.com/partners/irp/?cid=irp-17855" target="_blank" rel="noreferrer">
              https://quickbooks.intuit.com/
            </a>
          </Typography>
        </Grid>
        <Grid item>
          <Typography align="center" color="textSecondary">
            This feature requires that you have a QuickBooks Essentials plan or higher, starting at $38.50/month.
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  supportContacts: [
    {
      type: 'Support',
      contact: (
        <a
          href="https://help.housecallpro.com/en/collections/2496120-quickbooks-desktop-integration"
          target="_blank"
          rel="noreferrer"
        >
          Support Articles
        </a>
      ),
    },
  ],
};

export default QuickbooksDesktopStrategy;
